import {Directive, OnInit, OnChanges, Input, SimpleChanges} from '@angular/core';

declare var jQuery: any;

const GREEN_TO_YELLOW = [
  '#3CC778',               // > 5
  '#5FC168',               // 6
  '#83BB59',               // 7
  '#A7B549',               // 8
  '#CBAF3A',               // 9
  '#EFAA2B',               // 10
];

const YELLOW_TO_RED = [
  '#EFAA2B',              // 11
  '#F19931',              // 20
  '#F38837',              // 40
  '#F5783E',              // 60
  '#F76744',              // 80
  '#FA574B'               // 100
];

@Directive({
    selector: 'app-progress-circle',
    inputs: ['value']
})
export class ProgressCircleDirective implements OnInit, OnChanges {

    @Input() classref: string;
    @Input() max: number;
    value: number;
    @Input() locked: boolean;
    @Input() icon: string;
    @Input() reverse: boolean;
    @Input() overridecolor: string;

    constructor() {
    }

    ngOnInit() {

    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
          if (propName === 'value') {
            this.updateChart();
          }
        }
    }

    updateChart() {
      jQuery(this.classref + ' svg').css('visibility', 'hidden');
      jQuery(this.classref).circleProgress({
        max: this.max,
        value: this.value
      });

      jQuery(this.classref + ' svg .icon-circle').remove();

      setTimeout(() => {
        const dAttr = jQuery(this.classref + ' svg path').attr('d');
        if (dAttr) {
          const dAttrArray = dAttr.split(' ');
          const defsEl = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
          jQuery(defsEl).html('<linearGradient id=\'grad\' x1="0" y1="1" x2="0" y2="0" ><stop offset="0.85" stop-color=\'#fa574b\'/><stop offset="1" stop-color=\'#EFAA2B\'/></linearGradient>');
          jQuery(this.classref + ' svg').prepend(defsEl);
          const circleEl  = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
          jQuery(circleEl).attr('cx', dAttrArray[9]);
          jQuery(circleEl).attr('cy', dAttrArray[10]);
          jQuery(circleEl).attr('r', '7');
          jQuery(circleEl).attr('fill', '#FA574B');
          jQuery(circleEl).attr('stroke', 'white');
          jQuery(circleEl).attr('stroke-width', '1');
          jQuery(circleEl).attr('class', 'icon-circle');
          jQuery(this.classref + ' svg text').before(circleEl);
          jQuery(this.classref + ' svg text').text('!');
          if (this.icon) {
            jQuery(this.classref + ' svg text').html(this.icon);
          }
          jQuery(this.classref + ' svg text').attr('stroke', 'none');
          jQuery(this.classref + ' svg text').attr('fill', '#ffffff');
          jQuery(this.classref + ' svg text').attr('dy', '0.33em');
          jQuery(this.classref + ' svg text').attr('x', dAttrArray[9]);
          jQuery(this.classref + ' svg text').attr('y', dAttrArray[10]);
          jQuery(this.classref + ' svg text').show();
          jQuery(this.classref + ' svg').css('visibility', 'visible');
          let color = '#3CC778';
          if (this.reverse) {
            color = '#FA574B';
          }
          if (this.overridecolor) {
            color = this.overridecolor;
            jQuery(circleEl).attr('fill', color);
          } else {
            if (this.value > 5 && this.value <= 10) {
              color = GREEN_TO_YELLOW[Math.round((((this.value - 5) / 5) * 100) / 20)];
              if (this.reverse) {
                const arraycopy = [...YELLOW_TO_RED];
                color = arraycopy[Math.round((((this.value - 10) / 90) * 100) / 20)];
              }
            } else if (this.value < 100) {
              color = YELLOW_TO_RED[Math.round((((this.value - 10) / 90) * 100) / 20)];
              if (this.reverse) {
                const arraycopy = [...GREEN_TO_YELLOW];
                color = arraycopy[Math.round((((this.value - 5) / 5) * 100) / 20)];
              }
            }
          }
          jQuery(this.classref + ' svg .circle-progress-value').attr('stroke', color);
        }
      }, 1500);
    }
}
